import { useQuery } from "react-query";
import { BalancoFinanceiroPdfResponse, FiltroRelatorioBalancoFinanceiro } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

export function useRelatorioDemonstrativoReceitaDespesaPdf(query?: FiltroRelatorioBalancoFinanceiro) {
  return useQuery<BalancoFinanceiroPdfResponse, AxiosError>(
    ['/v1/relatorios/financeiro/balanco-financeiro/pdf', query],
    async () => {
      const {data} = await http.get('/v1/relatorios/financeiro/balanco-financeiro/pdf', {
        params: query
      })

      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useRelatorioDemonstrativoReceitaDespesaPdf;
